/* eslint-disable no-use-before-define */
import { getCoutries } from '@actions/countries'
import { getAllLanguagesList } from '@actions/locale'
import { getSectionTree } from '@actions/sections'
import { getProfilesCatalog } from '@actions/profiles'
import { removeDisallowedSectionsTree, removeCountriesSectionsTree } from '@actions/sessionPermission'
import { getTransactionName } from '@actions/bitacora'

import { SET_CATALOG } from '@constants/actionType'
import { LANGUAGE_DEFAULT } from '@constants/general'

import { getValueLanguageObj } from '@utils/general'
import api from '@utils/api'
import i18n from '../i18n';


export const getCatalogs = () => async (dispatch, _getState) => {
  await dispatch(getSectionTree())
  await dispatch(getAllLanguagesList({type: 'all'}))
  await dispatch(getCoutries({type: 'visible'}))
  await dispatch(getWorkstationCatalog())
  await dispatch(getProfilesCatalog({type: 'visible'}))
  await dispatch(getTransactionName())
  return true
}

export const setFormattedCatalogs = () => async (dispatch, getState) => {
  dispatch(setCatalogCurrentSectionTree())
  dispatch(setCatalogLanguageTabs())
  dispatch(setCatalogLanguageItems())
  dispatch(setCatalogLanguageKeys())
  dispatch(setCatalogCurrentCountries())
  dispatch(setCatalogCurrentWorkstation())
  dispatch(setCatalogCurrentProfiles())
  return true
}

// export const getCategoriesSectionCatalog = () => async (dispatch, _getState) => {
//   // const response = [{"key":"1","label":"./","children":[{"key":"1.1","label":"Estructura","parentKey":"1","children":[{"key":"1.1.1","label":"Materias","parentKey":"1.1","children":[{"key":"1.1.1.1","label":"Datos Personales","parentKey":"1.1.1","children":[{"key":"1.1.1.1.1","label":"Política de Privacidad","parentKey":"1.1.1.1"},{"key":"1.1.1.1.2","label":"Políticas, guías, manuales y lineamientos","parentKey":"1.1.1.1"},{"key":"1.1.1.1.3","label":"Países, Políticas, Documentos","parentKey":"1.1.1.1","children":[{"key":"1.1.1.1.3.1","label":"México","parentKey":"1.1.1.1.3","children":[{"key":"1.1.1.1.3.1.1","label":"Legislación y guías","parentKey":"1.1.1.1.3.1"},{"key":"1.1.1.1.3.1.2","label":"Análisis de legislación","parentKey":"1.1.1.1.3.1"},{"key":"1.1.1.1.3.1.3","label":"Aviso de privacidad","parentKey":"1.1.1.1.3.1"}]},{"key":"1.1.1.1.3.2","label":"Brasil","parentKey":"1.1.1.1.3"},{"key":"1.1.1.1.3.3","label":"Colombia","parentKey":"1.1.1.1.3"}]},{"key":"1.1.1.1.4","label":"Prevención del Delito","parentKey":"1.1.1.1"},{"key":"1.1.1.1.5","label":"Cumplimiento Laboral","parentKey":"1.1.1.1"},{"key":"1.1.1.1.6","label":"Anticorrupción","parentKey":"1.1.1.1"}]}]},{"key":"1.1.2","label":"Comités","parentKey":"1.1"},{"key":"1.1.3","label":"Compliance Officers Subsidiarias","parentKey":"1.1"}]}]}]
//   const response = await api.getPositions()
//   const response = {"id":1,"id_padre":0,"nombre":{"es":"Home"},"hijos":[{"id":2,"id_padre":1,"nombre":{"es":"Como Operamos"},"hijos":[{"id":3,"id_padre":2,"nombre":{"es":"Oficialía de Cumplimiento de América Móvil"}},{"id":4,"id_padre":2,"nombre":{"es":"Responsabilidades de la Oficialía de Cumplimiento"}},{"id":5,"id_padre":2,"nombre":{"es":"Materias del PIC"}},{"id":6,"id_padre":2,"nombre":{"es":"Herramientas del  PIC"}},{"id":7,"id_padre":2,"nombre":{"es":"Valores y Principios"}},{"id":8,"id_padre":2,"nombre":{"es":"Directorio de la Oficialía de Cumplimiento"}}]},{"id":9,"id_padre":1,"nombre":{"es":"Programa de Integridad y Cumplimiento (PIC)"},"hijos":[{"id":10,"id_padre":9,"nombre":{"es":"Documentos"},"hijos":[{"id":11,"id_padre":10,"nombre":{"es":"Datos personales"},"hijos":[{"id":12,"id_padre":11,"nombre":{"es":"México"},"hijos":[{"id":13,"id_padre":12,"nombre":{"es":"Autoridad en el País (Instituto Nacional de Transparencia, Acceso a la Información y Protección de Datos Personales“INAI”)"}},{"id":14,"id_padre":12,"nombre":{"es":"Legislación y guías emitidas por la autoridad"},"hijos":[{"id":15,"id_padre":14,"nombre":{"es":"Leyes y Reglamento"}},{"id":16,"id_padre":14,"nombre":{"es":"Normatividad Secundaria"}},{"id":17,"id_padre":14,"nombre":{"es":"Otros documentos relevantes"}}]},{"id":18,"id_padre":12,"nombre":{"es":"Políticas, guías, manuales y lineamientos de Protección de datos personales en México"}},{"id":19,"id_padre":12,"nombre":{"es":"Telcel"},"hijos":[{"id":20,"id_padre":19,"nombre":{"es":"Materiales de capacitación concientización y entrenamiento"}},{"id":21,"id_padre":19,"nombre":{"es":"Aviso de Privacidad"}},{"id":22,"id_padre":19,"nombre":{"es":"Políticas  y Procedimientos"}}]}]}]},{"id":23,"id_padre":10,"nombre":{"es":"Prevención de Lavado de Dinero"}},{"id":24,"id_padre":10,"nombre":{"es":"Prevención del Delito"}},{"id":25,"id_padre":10,"nombre":{"es":"Cumplimiento Laboral"}},{"id":26,"id_padre":10,"nombre":{"es":"Anticorrupción"}}]},{"id":27,"id_padre":9,"nombre":{"es":"Formularios  (Procesos)"}}]},{"id":28,"id_padre":1,"nombre":{"es":"Cursos de Capacitación"}},{"id":29,"id_padre":1,"nombre":{"es":"Avisos"}},{"id":30,"id_padre":1,"nombre":{"es":"Dummy"}}]}
//   dispatch({
//     type: SET_CATALOG,
//     payload: {nameCatalog: 'categoriesSectionCatalog', data: response}
//   })
//   return response
// }

// export const getLanguagesCatalog = () => async (dispatch, _getState) => {
//   const response = [{"id":1,"fc_nombre":{"en":"Spanish","es":"Español","pt":"Espanhol"},"fc_clave":"es","fc_orden":1},{"id":2,"fc_nombre":{"en":"English","es":"Inglés","pt":"Inglês"},"fc_clave":"en","fc_orden":2},{"id":3,"fc_nombre":{"en":"Portuguese","es":"Portugués","pt":"Português"},"fc_clave":"pt","fc_orden":3}]

//   dispatch({
//     type: SET_CATALOG,
//     payload: {nameCatalog: 'languagesCatalog', data: response}
//   })
//   return response
// }

// export const getCountriesCatalog = () => async (dispatch, _getState) => {
//   const response = [{"id":1,"fc_nombre":{"en":"Mexico","es":"México","pt":"México"},"fc_orden":1},{"id":2,"fc_nombre":{"en":"Brazil","es":"Brasil","pt":"Brasil"},"fc_orden":2},{"id":3,"fc_nombre":{"en":"Colombia","es":"Colombia","pt":"Colômbia"},"fc_orden":3}]

//   dispatch({
//     type: SET_CATALOG,
//     payload: {nameCatalog: 'countriesCatalog', data: response}
//   })
//   return response
// }

export const getWorkstationCatalog = () => async (dispatch, _getState) => {
  // const response = [{"id":1,"fc_nombre":{"en":"Director","es":"Director","pt":"Diretor"},"fc_navega":"ALL","fc_editable":1},{"id":2,"fc_nombre":{"en":"Manager","es":"Gerente","pt":"Gerente"},"fc_navega":"ALL","fc_editable":1},{"id":3,"fc_nombre":{"en":"Provider","es":"Provedor","pt":"Fornecedor"},"fc_navega":"ALL","fc_editable":1},{"id":4,"fc_nombre":{"en":"Consultant","es":"Consultor","pt":"Consultor"},"fc_navega":"ALL","fc_editable":1},{"id":5,"fc_nombre":{"en":"Representative","es":"Representante","pt":"Representante"},"fc_navega":"ALL","fc_editable":1}]
  const response = await api.getPositions()
  if (!response?.status) {
    dispatch({
      type: SET_CATALOG,
      payload: {nameCatalog: 'workstationCatalog', data: response?.data || []}
    })
  }
}

export const setCatalogLanguageTabs = (data = null) => async (dispatch, getState) => {
  const getCurrentLanguage = i18n.language
  const { languagesCatalog } = getState().catalogs
  const newCatalog = data || languagesCatalog.map(item => {
    if (item.clave === 'es') return { label: `${item.nombre[getCurrentLanguage] || item.nombre[LANGUAGE_DEFAULT]} (${i18n.t('Obligatorio')})`, key: item.clave}
    return { label: item.nombre[getCurrentLanguage] || item.nombre[LANGUAGE_DEFAULT], key: item.clave }
  })
  dispatch({
    type: SET_CATALOG,
    payload: {nameCatalog: 'tabsLanguageCatalog', data: newCatalog}
  })
  return newCatalog
}
export const setCatalogLanguageItems = (data = null) => async (dispatch, getState) => {
  const getCurrentLanguage = i18n.language
  const { languagesCatalog } = getState().catalogs
  const newCatalog = data || languagesCatalog.map(item => ({ label: item.nombre[getCurrentLanguage] || item.nombre[LANGUAGE_DEFAULT], key: item.clave }))

  dispatch({
    type: SET_CATALOG,
    payload: {nameCatalog: 'itemsLanguageCatalog', data: newCatalog}
  })
  return newCatalog
}
export const setCatalogLanguageKeys = (data = null) => async (dispatch, getState) => {
  const { languagesCatalog } = getState().catalogs
  const keysLenguages = data || languagesCatalog.map(item => (item.clave))

  dispatch({
    type: SET_CATALOG,
    payload: {nameCatalog: 'keysLanguageCatalog', data: keysLenguages}
  })
  return keysLenguages
}
export const setCatalogCurrentCountries = (data = null) => async (dispatch, getState) => {
  const { countriesCatalog } = getState().catalogs
  const countryesCatalog = data || countriesCatalog.map(item =>  ({ label: getValueLanguageObj(item.nombre), id: item.id }))

  dispatch({
    type: SET_CATALOG,
    payload: {nameCatalog: 'countriesCurrentCatalog', data: countryesCatalog}
  })
  return countryesCatalog
}

export const setCatalogCurrentWorkstation = () => async (dispatch, getState) => {
  const { workstationCatalog } = getState().catalogs
  const workstationsCatalog = workstationCatalog.map(item =>  ({ label: item.nombre, id: item.nombre }))

  dispatch({
    type: SET_CATALOG,
    payload: {nameCatalog: 'workstationsCurrentCatalog', data: workstationsCatalog}
  })
  return workstationsCatalog
}
export const setCatalogCurrentProfiles = (data = null) => async (dispatch, getState) => {
  const { profileCatalog } = getState().catalogs
  const profilesCatalog = data || profileCatalog.map(item =>  ({ label: getValueLanguageObj(item.nombre), id: item.id, ...item }))

  dispatch({
    type: SET_CATALOG,
    payload: {nameCatalog: 'profilesCurrentCatalog', data: profilesCatalog}
  })
  return profilesCatalog
}

export const setCatalogCurrentSectionTree = () => async (dispatch, getState) => {
  const { categoriesSectionCatalog } = getState().catalogs
  await dispatch(removeDisallowedSectionsTree(categoriesSectionCatalog))
  await dispatch(removeCountriesSectionsTree(categoriesSectionCatalog))

  const cloneSectionCatalog =  {...categoriesSectionCatalog}
  const children = formattedSectionTree(cloneSectionCatalog.hijos)
  cloneSectionCatalog.children = children
  cloneSectionCatalog.key = cloneSectionCatalog.id
  cloneSectionCatalog.label = getValueLanguageObj(cloneSectionCatalog.nombre)
  delete cloneSectionCatalog.hijos
  delete cloneSectionCatalog.id_padre

  dispatch({
    type: SET_CATALOG,
    payload: {nameCatalog: 'sectionTreeCurrentCatalog', data: [cloneSectionCatalog]}
  })
  return cloneSectionCatalog
}

const formattedSectionTree = (data) => data.map(item => {
    item.label = getValueLanguageObj(item.nombre)
    item.key = item.id
    item.children = item.hijos
    item.parentKey = item.id_padre
    delete item.hijos
    delete item.id_padre

    if (item.children) formattedSectionTree(item.children)
    return item
})
